import {
  Activity,      // "horse" (fallback; Lucide has no horse icon in this bundle)
  MapPin,        // "pin"
  Bike,          // fallback
  HeartPulse,    // "heart-pulse"
  Pencil,        // "pencil"
  FileText,      // "invoice"
  Package,       // "package"
  Trophy,        // "trophy"
  Coffee,        // "coffee"
  Sun,           // "sun"
  Cloud,         // "cloud"
  CloudSun,      // "sun-cloud"
  CloudFog,      // "cloud-fog"
  CloudDrizzle,  // "cloud-drizzle"
  CloudRain,     // "cloud-rain"
  CloudSnow,     // "cloud-snow"
  CloudLightning,// "cloud-lightning"
  Snowflake,     // "snowflake"
  Thermometer,   // "thermometer"
  AlertTriangle,
} from "lucide-react";

/**
 * Central mapping from BACKEND SEMANTIC ICON KEYS to Lucide components.
 *
 * The backend never returns emoji anymore — it returns short semantic
 * strings like "cloud", "trophy", "pin". Rendering keeps to Lucide icons
 * everywhere in the UI so we get consistent stroke weight, colour, and
 * accessibility (no font-vs-emoji rendering surprises).
 *
 * If a key isn't in the map, the caller should fall back to a neutral
 * icon (AlertTriangle) rather than rendering the raw string — that way
 * a typo shows up loudly during development instead of silently leaking
 * server text into the UI.
 */
const ICON_MAP = {
  // Daily-summary highlight icons
  horse: Activity,        // no dedicated horse Lucide; Activity reads as "movement"
  pin: MapPin,
  activity: Activity,
  "heart-pulse": HeartPulse,
  pencil: Pencil,
  invoice: FileText,
  package: Package,
  trophy: Trophy,
  coffee: Coffee,

  // Weather icons
  sun: Sun,
  cloud: Cloud,
  "sun-cloud": CloudSun,
  "cloud-fog": CloudFog,
  "cloud-drizzle": CloudDrizzle,
  "cloud-rain": CloudRain,
  "cloud-snow": CloudSnow,
  "cloud-lightning": CloudLightning,
  snowflake: Snowflake,
  thermometer: Thermometer,
};

/**
 * Resolve a semantic icon key to a Lucide component.
 * Returns AlertTriangle if the key is unknown so gaps are visible.
 */
export function iconFor(key) {
  if (!key) return AlertTriangle;
  return ICON_MAP[key] || AlertTriangle;
}
